import { cn } from '@/lib/utils';
import { RotateCcw, Search, SearchCheck } from 'lucide-react';

const FilterContainer = ({
    show,
    title = 'Filters',
    children,
    onApply,
    onReset,
    maxHeight = '815px',
}) => {
    return (
        <div
            className={cn(
                'slide-transition overflow-hidden',
                show
                    ? `card mb-2 opacity-100 translate-y-0 sm:h-fit max-h-[${maxHeight}]`
                    : 'opacity-0 -translate-y-2 pointer-events-none max-h-0'
            )}
        >
            <div className="card-header card-title">{title}</div>

            <div className="card-body">
                <div className="flex flex-wrap items-center justify-start w-full gap-2">
                    {children}

                    <div className="flex flex-col w-max">
                        <div className="form-label invisible">.</div>
                        <div className="flex items-center gap-1">
                            <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={onApply}
                            >
                                <Search className='size-3.5' />
                                Apply
                            </button>

                            <button
                                type="button"
                                className="btn btn-sm btn-danger btn-outline"
                                onClick={onReset}
                            >
                                <RotateCcw className='size-3.5' />
                                Reset
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { FilterContainer };